import { api, setToken } from '../client/client.js';

export async function login(username, password) {
  const result = await api.post('/auth/login', { username, password });
  if (result.token) {
    setToken(result.token);
  }
  return result;
}

export async function getMe() {
  return api.get('/auth/me');
}

export function logout() {
  setToken(null);
}

export function listSessions() {
  return api.get('/auth/sessions');
}

export function revokeSession(id) {
  return api.delete(`/auth/sessions/${id}`);
}

export function getLogs() {
  return api.get('/logs');
}

export function subscribeLogs(onLog) {
  let source = null;
  let closed = false;
  let retryTimer = null;

  const connect = async () => {
    if (closed) return;

    let ticket;
    try {
      const result = await api.post('/auth/stream-ticket');
      ticket = result.ticket;
    } catch {
      retryTimer = setTimeout(connect, 3_000);
      return;
    }

    const BASE_URL = import.meta.env.VITE_API_URL;
    source = new EventSource(`${BASE_URL}/logs/stream?ticket=${encodeURIComponent(ticket)}`);

    source.onmessage = (event) => {
      try {
        const log = JSON.parse(event.data);
        onLog?.(log);
      } catch {}
    };

    source.onerror = () => {
      source.close();
      if (closed) return;
      retryTimer = setTimeout(connect, 3_000);
    };
  };

  connect();

  return () => {
    closed = true;
    if (retryTimer) clearTimeout(retryTimer);
    if (source) source.close();
  };
}
